import React from 'react';
import { StyledBlogEditorRowDisplayBlock, StyledBlogEditorRow, Title, RemoveButton, ContentTextarea, TitleTextarea } from '../BlogEditor.style';
import { FiMinus } from 'react-icons/fi';
import { ContentGroupProps } from '../interfaces';
import { memo } from 'react';

export const ContentGroup: React.FC<ContentGroupProps> = memo(({ group, onChange, onRemove }) => (
  <>
    <StyledBlogEditorRow>
      <Title htmlFor={`head-${group.id}`}>Head</Title>
      <TitleTextarea
        id={`head-${group.id}`}
        name={`head-${group.id}`}
        value={group.head}
        hasValue={group.head.length > 0}
        onChange={(e) => onChange(group.id, 'head', e.target.value)}
        rows={1}
      />
      <RemoveButton
        type="button"
        aria-label="Remove Content Group"
        onClick={(e) => {
          e.stopPropagation();
          onRemove(group.id);
        }}
      >
        {FiMinus({ size: 28, color: '#000000' })}
      </RemoveButton>
    </StyledBlogEditorRow>

    <StyledBlogEditorRow>
      <Title htmlFor={`subHead-${group.id}`}>Sub Head</Title>
      <TitleTextarea
        id={`subHead-${group.id}`}
        name={`subHead-${group.id}`}
        value={group.subHead}
        hasValue={group.subHead.length > 0}
        onChange={(e) => onChange(group.id, 'subHead', e.target.value)}
        rows={1}
      />
    </StyledBlogEditorRow>

    <StyledBlogEditorRowDisplayBlock>
      <Title htmlFor={`description-${group.id}`}>Description</Title>
      <ContentTextarea
        id={`description-${group.id}`}
        name={`description-${group.id}`}
        value={group.description}
        hasValue={group.description.length > 0}
        onChange={(e) => onChange(group.id, 'description', e.target.value)}
        rows={6}
      />
    </StyledBlogEditorRowDisplayBlock>
  </>
));

ContentGroup.displayName = 'ContentGroup';
